import React, { useState } from "react";
import { Box, IconButton, Menu, MenuItem, Typography } from "@mui/material";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import LinkIcon from "@mui/icons-material/Link";
import { BarChart, RemoveCircleOutline } from "@mui/icons-material";

const TableActions = ({ rowData, onDelete, onShowChart }) => {
  const [anchorEl, setAnchorEl] = useState(null);

  const open = Boolean(anchorEl);

  const handleOpenMenu = (event) => setAnchorEl(event.currentTarget);
  const handleCloseMenu = () => setAnchorEl(null);

  return (
    <Box sx={{ display: "flex", justifyContent: "center" }}>
      <IconButton onClick={handleOpenMenu}>
        <MoreVertIcon />
      </IconButton>
      <Menu anchorEl={anchorEl} open={open} onClose={handleCloseMenu}>
        {rowData.chart && (
          <MenuItem
            onClick={() => {
              onShowChart(rowData);
              handleCloseMenu();
            }}
          >
            <BarChart fontSize="small" sx={{ mr: 2 }} />
            <Typography variant="body2">نمایش نمودار</Typography>
          </MenuItem>
        )}
        {onDelete && (
          <MenuItem
            onClick={() => {
              onDelete(rowData.id);
              handleCloseMenu();
            }}
          >
            <RemoveCircleOutline
              fontSize="small"
              color="error"
              sx={{ mr: 2 }}
            />
            <Typography variant="body2">حذف سطر</Typography>
          </MenuItem>
        )}
        {rowData.links &&
          rowData.links.map((data, i) => (
            <MenuItem
              key={i}
              onClick={handleCloseMenu}
              component="a"
              href={data.link}
              target="_blank"
            >
              <LinkIcon fontSize="small" sx={{ mr: 2 }} />
              <Typography variant="body2">{data.name}</Typography>
            </MenuItem>
          ))}
      </Menu>
    </Box>
  );
};

export default TableActions;
